module.exports = __webpack_public_path__ + "img/point2.65265c99.png";